import { Box } from '@material-ui/core'

import { useUserProvider } from '../../../components/Context/UserContext'
import { isConsole } from '../../../config/config'
import { User } from '../../../models/user'
import { ProfileCDL } from './ProfileCDL'
import { ProfileContact } from './ProfileContact'
import { ProfileEmergencyContact } from './ProfileEmergencyContact'
import { ProfilePersonalAccountInfo } from './ProfilePersonalAccountInfo'
import { ProfilePersonalEquipmentInfo } from './ProfilePersonalEquipmentInfo'
import { ProfilePersonalInfo } from './ProfilePersonalInfo'
import { ProfileReferrals } from './ProfileReferrals'

interface ProfileSectionProps {
  user: User
  renderDeactivateUserButton?: () => React.ReactNode
}

export function ProfileSection({ user, renderDeactivateUserButton }: ProfileSectionProps) {
  const { subscription, loggedInUser, permissions } = useUserProvider()
  const isModifyingSelf = loggedInUser?.id === user.id
  const canChangeCustomUser = permissions.canChangeCustomUser
  const canEdit = isConsole() ? canChangeCustomUser : (isModifyingSelf || loggedInUser?.isTeamAdmin) ?? false

  return (
    <div>
      <ProfileContact user={user} canEdit={canEdit} />
      {isConsole() && user.defaultTeamMembership?.driverAssignedTruck && (
        <>
          <Box mt={3} />
          <ProfilePersonalEquipmentInfo user={user} canEdit={canEdit} />
        </>
      )}
      <Box mt={3} />
      <ProfilePersonalInfo user={user} canEdit={canEdit} />
      {subscription?.isPremium && canEdit ? (
        <>
          <Box mt={3} />
          <ProfileCDL user={user} canEdit={canEdit} />
          <Box mt={3} />
          <ProfileEmergencyContact user={user} canEdit={canEdit} />
        </>
      ) : null}
      {isConsole() && (
        <>
          <Box mt={3} />
          <ProfilePersonalAccountInfo user={user} canEdit={canEdit} />
        </>
      )}
      {isConsole() && permissions.canViewReferrals && (
        <>
          <Box mt={3} />
          <ProfileReferrals user={user} canEdit={canEdit} />
        </>
      )}
      {renderDeactivateUserButton?.()}
    </div>
  )
}
